const PRESET_LENGTHS = {
  last_7_days: 7,
  last_30_days: 30,
  last_90_days: 90,
};

export function kolkataToday(now = new Date()) {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now);
}

function parseDay(iso) {
  const [year, month, day] = String(iso).slice(0, 10).split('-').map(Number);
  return Date.UTC(year, month - 1, day);
}

function formatDay(utcMs) {
  const date = new Date(utcMs);
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${date.getUTCFullYear()}-${month}-${day}`;
}

export function addDays(iso, days) {
  return formatDay(parseDay(iso) + days * 86400000);
}

export function resolveActiveRange(dateRange, today = kolkataToday()) {
  const preset = dateRange?.preset;
  if (preset === 'all_time') return null;
  if (preset === 'today') {
    return { start: today, end: today };
  }
  if (preset === 'yesterday') {
    const yDay = addDays(today, -1);
    return { start: yDay, end: yDay };
  }
  if (preset === 'this_week') {
    const noon = new Date(`${today}T12:00:00Z`);
    const mondayOffset = (noon.getUTCDay() + 6) % 7;
    return { start: addDays(today, -mondayOffset), end: today };
  }
  if (preset === 'this_month') {
    return { start: `${today.slice(0, 8)}01`, end: today };
  }
  if (PRESET_LENGTHS[preset]) {
    return {
      start: addDays(today, -(PRESET_LENGTHS[preset] - 1)),
      end: today,
    };
  }
  if (dateRange?.start && dateRange?.end) {
    return { start: String(dateRange.start).slice(0, 10), end: String(dateRange.end).slice(0, 10) };
  }
  return null;
}

export function previousPeriod(dateRange, today = kolkataToday()) {
  const range = resolveActiveRange(dateRange, today);
  if (!range) return null;
  const dayCount = Math.round((parseDay(range.end) - parseDay(range.start)) / 86400000) + 1;
  if (dayCount < 1) return null;
  const prevEnd = addDays(range.start, -1);
  return {
    dayCount,
    prevStart: addDays(prevEnd, -(dayCount - 1)),
    prevEnd,
  };
}

export function formatPeriodChange(current, previous, dayCount) {
  const currentNumber = Number(current);
  const previousNumber = Number(previous);
  if (!Number.isFinite(currentNumber) || !Number.isFinite(previousNumber) || !dayCount) {
    return { text: '', direction: 'flat' };
  }
  const suffix = `vs previous ${dayCount} days`;
  if (previousNumber === 0) {
    if (currentNumber === 0) return { text: `0% ${suffix}`, direction: 'flat' };
    const direction = currentNumber > 0 ? 'up' : 'down';
    return { text: `${currentNumber} ${suffix}`, direction };
  }
  const pct = Math.round(((currentNumber - previousNumber) / Math.abs(previousNumber)) * 100);
  let direction = 'flat';
  if (pct > 0) direction = 'up';
  if (pct < 0) direction = 'down';
  return { text: `${pct}% ${suffix}`, direction };
}
